
import axiosInstance from '../services/AxiosInstance';




export function getNewRrtbfApprovalTasks(user) {
    

    let user_email = "eddie.ruiz@lennar.com"
    let userTwo = "carlos.garcell@lennar.com"
    const newApprovalTaskRoute = `${process.env.REACT_APP_AZURE_NEW_APPROVAL_TASKS_ROUTE}${userTwo}`


    return axiosInstance.get(newApprovalTaskRoute)
        .then(response => {
            return response.data.data;
        })
        .catch(error => {
            console.error('Error fetching NEW RTBF approval tasks:', error);
            throw error;
        });
}



export function getRrtbfApprovalHistory(user) {
    console.log("User retrieving approvals history : ", user)
    let user_email = "eddie.ruiz@lennar.com"
    let userTwo = "carlos.garcell@lennar.com"
    
    const approvalsHistoryRoute = `${process.env.REACT_APP_AZURE_APPROVALS_HISTORY_ROUTE}`


    return axiosInstance.get(approvalsHistoryRoute)
        .then(response => {
            return response.data.data;
        })
        .catch(error => {
            console.error('Error fetching RTBF approvals:', error);
            throw error;
        });
}


export function submitRTBFApprovalTasks(approvals) {

    const newApprovalTaskSubmissionRoute = process.env.REACT_APP_AZURE_RTBF_APPROVAL_TASK_SUBMISSION_ROUTE;

    return axiosInstance.post(newApprovalTaskSubmissionRoute, approvals)
        .then(response => {
            
            
            return response.data.data;
        })
        .catch(error => {
            console.error('Error fetching RTBF approvals:', error);
            throw error;
        });
}

// CLASSIFICATION SERVICES

export function getClassificationApprovalHistory(user) {
    console.log("User retrieving approvals history : ", user)
    
    const classificationApprovalsHistoryRoute = process.env.REACT_APP_AZURE_CLASSIFICATION_APPROVALS_HISTORY_ROUTE

    
    

    
    return axiosInstance.get(classificationApprovalsHistoryRoute)
        .then(response => {
            
            return response.data.data;
        })
        .catch(error => {
            console.error('Error fetching Classification approvals:', error);
            throw error;
        });
}


export function getNewClassificationApprovalTasks(user) {
    

    let url = process.env.REACT_APP_AZURE_NEW_CLASSIFICATION_APPROVAL_TASKS_ROUTE;


    return axiosInstance.get(url)
        .then(response => {
            console.log("RESPONSE FROM API");
            console.log(response.data.data);
            let onlyFewTasks = response.data.data.slice(0, 50);
            // return response.data.data;
            return response.data.data;
        })
        .catch(error => {
            console.error('Error fetching NEW Classification approval tasks:', error);
            throw error;
        });
}


export function submitClassificationApprovalTask(approval) {
    const newClassificationApprovalTaskSubmissionRoute = process.env.REACT_APP_AZURE_CLASSIFICATION_APPROVAL_TASK_SUBMISSION_ROUTE;
    console.log(newClassificationApprovalTaskSubmissionRoute)
    console.log("APPROVAL or DENY SUBMISSION")
    console.log(approval)
    return axiosInstance.post(newClassificationApprovalTaskSubmissionRoute, approval)
        .then(response => {
            console.log("RESPONSE FROM API");
            console.log(response);
            const resultData = response.data[0].classificationProcedureResult;
            if (resultData && resultData.result) {
                return resultData.result
            } else if (resultData) {
                return resultData.status;
            } else if (response.data[0].data){
                return response.status
            } else {
                throw new Error('Unexpected response structure');
            }
        })
        .catch(error => {
            console.error('Error submitting classification approval:', error);
            throw error;
        });
}
